import { useMemo } from 'react';
import { useMechanicValidatorDevelopmentCard } from '../../../store/selectors/useMechanicValidatorDevelopmentCard.ts';
import { cardEnumsToCardState } from '../../../utils/cards.ts';
export const usePlayerInfoSectionContentUsedDevsProps = (playerColor)=>{
    const developmentCardsValidator = useMechanicValidatorDevelopmentCard();
    const usedDevelopmentCards = developmentCardsValidator === null || developmentCardsValidator === void 0 ? void 0 : developmentCardsValidator.getDevelopmentCardsPlayerState(playerColor).developmentCardsUsed;
    if (usedDevelopmentCards == undefined) return null;
    const cardStateUnordered = cardEnumsToCardState(usedDevelopmentCards);
    return useMemo(()=>({
            cardState: cardStateUnordered
        }), [
        usedDevelopmentCards
    ]);
};
